<template>
  <div class="memberManage">
    <el-col :span="24" style="padding-bottom: 0px;margin-bottom:20px">
      <el-form :inline="true" :model="form" label-width="auto">


        <!-- <el-form-item label>
          <div class="block">
            <el-date-picker
              v-model="form.start_at"
              type="month"
              @change="onPick"
              value-format="yyyy-MM"
              placeholder="选择月"
            ></el-date-picker>
          </div>
        </el-form-item> -->


                 <el-date-picker
                  v-model="value1"
                  type="monthrange"
                  range-separator="至"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份"
                  value-format="yyyy-MM"
                  @change="pickerOptions"
                ></el-date-picker>

                <span style="padding-left:30px">总金额：{{money}}</span>  
     
      </el-form>
    </el-col>

    <el-col :span="24">
      <el-table
        :data="tableData"
        border
        :sort-orders="['ascending', 'descending']"
        sortable
        style="width:100%"
        :default-sort="{prop: 'date', order: 'descending'}"
        @sort-change="sortChange"
      >
        <el-table-column label="时间"  align="center">
            <template slot-scope="scope"> 
              <span>
                       {{scope.row.create_date.substring(0,7)}}
              </span>
            </template>
        </el-table-column>
        <el-table-column label="代理账号" prop="account_number" align="center"></el-table-column>
        <el-table-column label="代理名称" prop="agent_name" align="center"></el-table-column>
      

         <el-table-column label="账户类型" prop="type" align="center" v-if="showAccount"></el-table-column>
        <!-- <el-table-column label="包月分成金额" prop="cyberFcj" align="center" sortable="custom"></el-table-column> -->
        <!-- <el-table-column label="包月充值金额" prop="cyberAmount" align="center" sortable="custom"></el-table-column>-->
        <el-table-column label="总分成" prop="money" align="center" sortable="custom"></el-table-column>

        <el-table-column label="包月分成" prop="month_money" align="center" sortable="custom"></el-table-column>

        <el-table-column label="扫码分成" prop="self_order_money" align="center" sortable="custom"></el-table-column>
          
      </el-table>
    </el-col>

    <el-pagination
      background
      layout="prev, pager, next"
      :total="count"
      @current-change="handleCurrentChange"
      style="margin-bottom: 20px;"
    ></el-pagination>
    <!-- <el-dialog title="提示" :visible.sync="useVisible" width="30%" center>
      <div class="tooltips">{{this.form.start}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="useVisible = false">取 消</el-button>
        <el-button type="primary" @click="stopRow()">确 定</el-button>
      </span>
    </el-dialog>-->
  </div>
</template>
<script>
import * as sysApi from "../../common/sys";
import { formatDate } from "../../common/utils";

export default {
  data() {
    return {
      showAccount: false,
      count: null,
      value1:"",
      money:"",
      // form: {
      //   searchKey: "",
      //   totalBalance: "",
      //   agentAmount: "",
      //   agentBalance: "",
      //   qrcodeAmount: "",
      //   qrcodeBalance: "",
      //   userAgents: "",
      //   userQrcode: "",
      //   date: "",
      //   starttime: "",
      //   endtime: "",
      //   start: ""
      // },
       params: {
        //  接口默认参数
        page: 1,
        start_at: ""
      },
      loading: false,
      // limit: false,
      // currentPage: 1,
      // useVisible: false,
      tableData: [],
      // total: 1,
      // sort: 1,
      // user_id: 0,
      // allId: [],
      // rowId: ""
      form: {
        account_number: "", //代理账号
        agent_name: "", //string代理昵称
        page: 1, //	integer页数
        sort: 1, //integer排序  -3,3直属金额   -2,2：下级代理充值金额，  -1,1:扫码分成金额，
        start_at: "", //string月份
        end_at:"",
      }
    };
  },
  created() {
    // if (localStorage.getItem("agent_type") === "管理员") {
    //   this.showAccount = true;
    // } else {
    //   this.showAccount = false;
    // }
    // if (localStorage.getItem("agent_type") == "三级代理") {
    //   this.limit = true;
    // } else {
    //   this.limit = false;
    // }
    // var date = new Date();
    // var year = date.getFullYear();
    // var month = date.getMonth() + 1;
    // month = month < 10 ? "0" + month : month;
    // var mydate = year.toString() + "-" + month.toString();
    // this.form.date = mydate;
    this.initQuery();
  },
  methods: {
    initQuery() {
       sysApi
        .sm_order_fc_self(this.form)
        .then(res => {
          if (res.code != 1) {
            return this.$message.error(res.result);
          }
      
          this.count = res.count;
          this.tableData = res.result;
          this.sumPage = res.sumPage;
          this.money = res.money.toFixed(2);
          console.log(this.tableData);
        })
        .catch(err => console.log("请求异常信息:" + err));
    },


    sortChange(column) {
      console.log(column);
      if (column.prop == "money") {
        if (column.order == "ascending") {
          this.form.sort = 1;
        } else {
          this.form.sort = -1;
        }
      } else if (column.prop == "other_order_money") {
        if (column.order == "ascending") {
          this.form.sort = 2;
        } else {
          this.form.sort = -2;
        }
      } else {
        if (column.order == "ascending") {
          this.form.sort = 3;
        } else {
          this.form.sort = -3;
        }
      }
      this.initQuery();
      // if (column.prop == "sumFcj" && column.order == "descending") {
      //   //降序
      //   this.sort = 1;
      // } else if (column.prop == "sumFcj" && column.order == "ascending") {
      //   this.sort = -1;
      // } else if (column.prop == "qrcodeFcj" && column.order == "descending") {
      //   this.sort = 2;
      // } else if (column.prop == "qrcodeFcj" && column.order == "ascending") {
      //   this.sort = -2;
      // } else if (
      //   column.prop == "qrcodeAmount" &&
      //   column.order == "descending"
      // ) {
      //   this.sort = 3;
      // } else if (column.prop == "qrcodeAmount" && column.order == "ascending") {
      //   this.sort = -3;
      // } else if (column.prop == "cyberFcj" && column.order == "descending") {
      //   this.sort = 4;
      // } else if (column.prop == "cyberFcj" && column.order == "ascending") {
      //   this.sort = -4;
      // } else if (column.prop == "cyberAmount" && column.order == "descending") {
      //   this.sort = 5;
      // } else if (column.prop == "cyberAmount" && column.order == "ascending") {
      //   this.sort = -5;
      // } else {
      //   this.sort = 0;
      // }
      // this.currentPage = 1;
      // this.init(this.sort);
    },
    // 搜索
    serchName() {
      this.initQuery();
    },
    // 时间
    pickerOptions(val) {
       this.form.start_at = val[0];
       this.form.end_at = val[1];
       this.initQuery();
    },
    // search() {
    //   this.currentPage = 1;
    //   this.init(this.sort);
    // },
    // 分页
    handleCurrentChange(val) {
 
      this.form.page = val;
      this.initQuery();
    }
    //   sysApi
    //     .shareDataList(pa)
    //     .then(res => {
    //       for (var i in res.data.list) {
    //         if (res.data.list[i].type == "一级代理") {
    //           res.data.list[i].type = "国代";
    //         } else if (res.data.list[i].type == "二级代理") {
    //           res.data.list[i].type = "一级代理";
    //         } else if (res.data.list[i].type == "三级代理") {
    //           res.data.list[i].type = "二级代理";
    //         } else {
    //           res.data.list[i].type = "普通网吧";
    //         }
    //       }
    //       this.tableData = res.data.list;
    //       this.total = res.count;
    //       this.form.totalBalance = res.data.statics.totalBalance;
    //       this.form.agentAmount = res.data.statics.agentAmount;
    //       this.form.agentBalance = res.data.statics.agentBalance;
    //       this.form.qrcodeAmount = res.data.statics.qrcodeAmount;
    //       this.form.qrcodeBalance = res.data.statics.qrcodeBalance;
    //       this.form.userQrcode = res.data.statics.userQrcode;
    //     })
    //     .catch(err => console.log("请求异常信息:" + err));
    // },
    // init(sort) {
    //   this.loading = true;
    //   var pa = {
    //     start_at: this.form.date, //"开始时间"
    //     end_at: "", //"结束时间"
    //     search_name: this.form.searchKey, //搜索名称
    //     user_id: 0, //代理商编号
    //     page: this.currentPage, //分页 当前页数
    //     sort: sort
    //   };
    //   sysApi
    //     .shareDataList(pa)
    //     .then(res => {
    //       for (var i in res.data.list) {
    //         if (res.data.list[i].type == "一级代理") {
    //           res.data.list[i].type = "国代";
    //         } else if (res.data.list[i].type == "二级代理") {
    //           res.data.list[i].type = "一级代理";
    //         } else if (res.data.list[i].type == "三级代理") {
    //           res.data.list[i].type = "二级代理";
    //         } else {
    //           res.data.list[i].type = "普通网吧";
    //         }
    //       }
    //       this.tableData = res.data.list;
    //       this.total = res.count;
    //       this.form.totalBalance = res.data.statics.totalBalance;
    //       this.form.agentAmount = res.data.statics.agentAmount;
    //       this.form.agentBalance = res.data.statics.agentBalance;
    //       this.form.qrcodeAmount = res.data.statics.qrcodeAmount;
    //       this.form.qrcodeBalance = res.data.statics.qrcodeBalance;
    //       this.form.userQrcode = res.data.statics.userQrcode;
    //       this.loading = false;
    //       console.log(res);
    //     })
    //     .catch(err => console.log("请求异常信息:" + err));
    // }
  }
};
</script>
<style lang="scss" scope>
.ul_div {
  overflow: hidden;
  width: 100% !important;
  /* position:fixed;
        bottom:20px; */
  border-top: 1px solid #333;
  border-bottom: 1px solid #333;
  border-right: 1px solid #333;
  margin-bottom: 20px;
  height: 50px;
  /* background: #fff !important; */
}

.ul_div li {
  float: left;
  margin-right: 50px;
  line-height: 50px;
  list-style: none;
  color: #333;
}

.ul_div li.li_li {
  width: 5px;
  background: #409eff;
  height: 50px;
  margin-right: 10px;
}

.el-table td,
.el-table th {
  padding: 10px 0 !important;
}

.content-wrapper .content {
  padding: 10px;
}
.form_item {
  float: right;
  .right_show {
    display: flex;
    border: 1px solid #e3e3e3;
    width: 700px;
    .right_box {
      flex: 1;
      text-align: center;
      border-right: 1px solid #e3e3e3;
      .right_text {
        font-size: 14px;
        color: #666c7c;
        span {
          font-size: 22px;
          color: #f14561;
        }
      }
    }
  }
}
</style>


